import { InputField, InputSelectFieldOptions } from 'components/molecules'
import { STOCK_OPTIONS } from 'domains/product/constants'

const ProductStockFilterField = () => (
  <>
    <InputField
      formGroupClassName={ 'mr-3' }
      type={ 'select' }
      name={ 'is_in_stock' }
      label={ 'STOCK' }
      bsSize={ 'sm' }
    >
      <InputSelectFieldOptions
        options={ STOCK_OPTIONS }
      />
    </InputField>
  </>
)

export default ProductStockFilterField
